// API requests configuration file
// baseURL => of the bureau-projet.api
import axios from "axios"

// BEFORE COMMIT => Change API URL

export default axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    "Content-type": "application/json",
  },
})
